import React from "react";
import * as Icons from "lucide-react";
import { Reveal } from "@/components/effects/Reveal";
import { WHY_CHOOSE } from "@/lib/data";

export const WhyChooseUs = () => {
  return (
    <section data-testid="why-choose-section" className="relative py-28 sm:py-36 bg-[#050507]">
      <div className="max-w-[1280px] mx-auto px-6 sm:px-10">
        <div className="max-w-2xl">
          <Reveal>
            <p className="text-[11px] tracking-luxe uppercase text-white/45 mb-4">— Why WelkomBiz</p>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[1.05]">
              <span className="text-chrome">Built for those who</span>{" "}
              <span className="italic text-magcyan">demand the very best</span>
              <span className="text-chrome">.</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 chrome-border rounded-md overflow-hidden">
          {WHY_CHOOSE.map((w, i) => {
            const Icon = Icons[w.icon] || Icons.Star;
            return (
              <Reveal key={w.title} delay={i * 70}>
                <div className="bg-[#070709] hover:bg-[#0c0c11] transition-colors p-7 sm:p-8 h-full">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center chrome-border bg-black/40 mb-5">
                    <Icon className="w-4 h-4 text-white" />
                  </div>
                  <h3 className="font-display text-xl text-chrome mb-2">{w.title}</h3>
                  <p className="text-sm text-white/55 font-body leading-relaxed">{w.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
